// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
export enum SubRegion {
None,
NorthernEurope,
WesternEurope,
SouthernEurope,
EasternEurope,
CentralAmerica,
NorthAmerica,
SouthAmerica,
EasternAfrica,
MiddleAfrica,
NorthernAfrica,
SouthernAfrica,
WesternAfrica,
CentralAsia,
EasternAsia,
SouthernAsia,
SouthEasternAsia,
WesternAsia,
AustraliaAndNewZealand,
Melanesia,
Polynesia,
Micronesia,
Caribbean,
}
